export const COMPLETED = 'COMPLETED'